import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M10.057 8h2.057v1.056h-2.057zM6.971 8H9.03v1.056H6.97zM3.886 8h2.057v1.056H3.886zm6.171 2.112h2.057v1.056h-2.057zm-3.086 0H9.03v1.056H6.97zm-3.085 0h2.057v1.056H3.886zm10.285 4.752V5.888a.52.52 0 0 0 .515-.528.52.52 0 0 0-.515-.528H11.43q.171-.528.171-1.056C11.6 1.723 10 .08 8 .08S4.4 1.723 4.4 3.776q0 .528.171 1.056H1.828a.52.52 0 0 0-.514.528.52.52 0 0 0 .514.528v8.976H.8v1.056h14.4v-1.056zM8 1.077c1.429 0 2.571 1.174 2.571 2.64S9.428 6.357 8 6.357s-2.571-1.173-2.571-2.64c0-1.466 1.143-2.64 2.571-2.64M6.971 14.864V13.28H9.03v1.584zm3.086 0v-2.112a.52.52 0 0 0-.514-.528H6.457a.52.52 0 0 0-.514.528v2.112H2.857V5.888H5.03A3.57 3.57 0 0 0 8 7.472c1.257 0 2.286-.645 2.971-1.584h2.172v8.976zm1.029-2.64h1.028v1.056h-1.028zm-7.2 0h1.028v1.056H3.886zm3.6-6.864h1.028V4.304h1.029V3.19H8.514V2.134H7.486V3.19H6.457v1.114h1.029z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }